import discord from "./discord"
import twitter from "./twitter"

export default {
    discord,
    twitter,
}

export const discordAuthUrl = "https://us-central1-wolves-capital.cloudfunctions.net/api/v1/auth/discord/" //"http://localhost:3001/v1/auth/discord/" // "https://discord.com/api/oauth2/authorize?client_id=1037758833948368960&redirect_uri=http%3A%2F%2Flocalhost%3A3000%2Fbrokers-grove%2Faccount&response_type=code&scope=identify%20guilds"
export const twitterAuthUrl = "https://us-central1-wolves-capital.cloudfunctions.net/api/v1/auth/twitter/" //"http://localhost:3001/v1/auth/twitter/"